import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import { routes } from './routes';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 公开路由 */}
        {routes.public.map((route, index) => (
          <Route key={route.path} {...route} />
        ))}
        
        {/* 受保护路由 */}
        <Route element={<PrivateRoute />}>
          {routes.private.map((route, index) => (
            <Route key={route.path} {...route} />
          ))}
        </Route>

        {/* 默认重定向 */}
        <Route path="*" element={<Navigate to={`/campaigns/invitations`} replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router; 